import React, { useState, useEffect, useRef } from 'react'
import Filter from '../../components/Filter'
import {
	Row,
	Col,
	Image,
	InputGroup,
	FormControl,
	Button
} from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
	faFileDownload,
	faChevronRight,
	faChevronLeft,
} from '@fortawesome/free-solid-svg-icons'
import styles from './Jobs.module.scss'
import EButton from '../../components/bootstrap-extended/EButton'
import 'react-day-picker/lib/style.css'
import ReactPaginate from 'react-paginate'
import { useNavigate, useLocation } from 'react-router-dom'
import moment from 'moment'
import { CSVLink } from 'react-csv'
import axios from 'axios'

interface DataProps {
	id: number
	title: string
	companyName: string
	jobPostStart: string
	jobPostEnd: string
	createdAt: string
	application: number
}

function useQuery() {
	const { search } = useLocation()
	return React.useMemo(() => new URLSearchParams(search), [search])
}

const Jobs = () => {
	const csvLink = useRef<any | null>(null)
	const navigate = useNavigate()
	const query = useQuery()

	const [jobs, setJobs] = useState<Array<DataProps> | null>([])
	const [pageNo, setPageNo] = useState('')
	const [toPage, setToPage] = useState<number>(0)
	const [isLoading, setIsLoading] = useState(true)

	const [dataExport, setDataExport] = useState<any[]>([])
	const [dataAggregate, setDataAggregate] = useState(0)

	const [keyword, setKeyword] = useState<string>('')
	const [filterPage, setFilterPage] = useState('')

	// pagination
	const [pageCount, setPageCount] = useState(0)
	const [itemOffset, setItemOffset] = useState(0)
	const itemsPerPage = 10

	const exportHeader = [
		{ label: 'Job Position', key: 'title' },
		{ label: 'Company Name', key: 'companyName' },
		{ label: 'Post Date', key: 'jobPostStart' },
		{ label: 'Expiry Date', key: 'jobPostEnd' },
		{ label: 'Updated At', key: 'createdAt' },
		{ label: 'Application', key: 'application' }
	]

	useEffect(() => {
		const toNum = () => {
			if (pageNo === '') {
				setItemOffset(0)
				setToPage(0)
			} else {
				const temp = parseInt(pageNo)
				const newOffset = (temp * 10 - 10)
				setItemOffset(newOffset)
				setToPage(temp - 1)
			}
		}
		toNum()
	}, [pageNo])

	const page = query.get('page')
	const keywordSeach = query.get('keyword')

	const filters = {
		page: (page !== null && parseInt(page)) ? page : 1,
		keyword: (keywordSeach !== null ? keywordSeach as string : '').replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\\{\\}\\[\]\\\\/]/gi, ''),
	}

	// event handlers
	const handlePageClick = (event: { selected: number }) => {
		window.location.href = getPaginationLink((event.selected + 1).toString())
	}

	const getPaginationLink = (page: string): string => {
		const keyword: string = filters.keyword as string
		return `/jobs?page=${page}&keyword=${encodeURIComponent(keyword)}`
	}

	const handleKeyDown = (e: any): void => {
		if (e.keyCode === 13) {
			redirectNewUrl()
		}
	}

	const redirectNewUrl = (): void => {
		const keywordSearch: string = keyword.replace(/[`~!@#$%^&*()_|+\-=?;:'".<>\\{\\}\\[\]\\\\/]/gi, '')
		window.location.href = `/jobs?page=1&keyword=${encodeURIComponent(keywordSearch)}`
	}

	const getAllJobs = async () => {
		try {
			const res = await axios.get(process.env.REACT_APP_ROUTE_GET_JOB as string + `?pageSize=${dataAggregate}&keyword=${filters.keyword}`)
			setDataExport(res.data.jobs.map((row) => ({
				...row,
				jobPostStart: moment(row.jobPostStart).format('DD MMM YYYY'),
				jobPostEnd: moment(row.jobPostEnd).format('DD MMM YYYY'),
				createdAt: moment(row.createdAt).format('DD MMM YYYY')
			})))
		} catch (err) {
			console.log(err)
		}
	}

	const numbersOnly = (val: string) => {
		const numsCheck = new RegExp('^[0-9]{1,6}$')//6 digits only
		if (numsCheck.test(val) || val === '') {
			setFilterPage(val)
		}
		if (parseInt(val) > pageCount) {
			setFilterPage(pageCount.toString())
		}
	}

	const submitPageNumber = () => {
		window.location.href = `/jobs?page=${filterPage}&keyword=${encodeURIComponent(filters.keyword)}`
	}

	//on load
	useEffect(() => {
		const getJobs = async () => {
			try {
				const res = await axios.get(process.env.REACT_APP_ROUTE_GET_JOB as string + `?page=${filters.page}&keyword=${filters.keyword}`)
				setJobs(res.data.jobs)
				setIsLoading(false)
				setPageCount(Math.ceil(res.data.jobAggregate / itemsPerPage))
				setKeyword(filters.keyword)
				setPageNo(filters.page.toString())
				setDataAggregate(res.data.jobAggregate)
			} catch (err) {
				console.log(err)
			}
		}
		getJobs()
	}, [])

	//export
	useEffect(() => {
		if (dataExport && csvLink && csvLink.current && csvLink.current.link) {
			setTimeout(() => {
				csvLink.current.link.click()
				setDataExport([])
			})
		}
	}, [dataExport])

	return (
		<div>
			<Row>
				<Col>
					<Filter />
				</Col>
			</Row>
			<Row className={styles.searchCompRow}>
				<Col style={{ display: 'flex', flexFlow: 'row wrap' }}>
					<Col lg={4} xs={12}>
						<InputGroup className={styles.searchInput}>
							<InputGroup.Text id="basic-addon1">
								{' '}<Image src='/img/search.png' alt='search' width='15' height='15' />
							</InputGroup.Text>
							<FormControl
								name='keyword'
								placeholder="Search job title"
								value={keyword}
								onChange={e => {
									setKeyword(e.target.value)
								}}
								onKeyDown={handleKeyDown}
							/>
						</InputGroup>
					</Col>
				</Col>
				<Col lg={2} md={2}>
					<div style={{ display: 'flex', justifyContent: 'flex-end' }}>
						<div onClick={getAllJobs}>
							<EButton
								buttonText='Export'
								icon={<FontAwesomeIcon icon={faFileDownload} />} isSubmitting={false} className={styles.cusBtn}
							/>
						</div>
						{dataExport.length > 0 ?
							<CSVLink
								data={dataExport}
								headers={exportHeader}
								filename={'Jobs.csv'}
								ref={csvLink}
							/>
							: undefined
						}
					</div>
				</Col>
			</Row>
			{/* table */}
			{/* header */}
			<div style={{ overflowX: 'auto' }}>
				<table style={{ width: '100%' }}>
					<div className={styles.tableHeader}>
						<Row className={styles.mobileViewSlideTable}>
							{['Job position', 'Company name', 'Post date', 'Expiry date', 'Updated at', 'Application'].map((val, index) => (
								<Col key={index} xs={2} className={index !== 0 ? 'text-center' : ''}>
									<h6>{val}</h6>
								</Col>
							))}
						</Row>
					</div>
					{/* items */}
					<div>
						{isLoading ? (
							<div className='text-center mt-3'>
								<p>Loading</p>
							</div>
						) : (
							jobs && jobs.map((job, index) => {
								return (
									<div key={index} className={styles.tableBody} onClick={() => navigate(`/jobs/${job.id}`)}>
										<Row className={styles.mobileViewSlideTable}>
											<Col xs={2} className='d-flex align-items-center'>
												<p style={{ textAlign: 'left', overflowWrap: 'break-word', paddingLeft: '1rem' }}>
													{job.title}
												</p>
											</Col>
											<Col xs={2} className='d-flex align-items-center justify-content-center text-center'><p>{job.companyName}</p></Col>
											<Col className={`d-flex align-items-center justify-content-center ${styles.noWrap}`}><p>{moment(job.jobPostStart).format('DD MMM YYYY')}</p></Col>
											<Col className={`d-flex align-items-center justify-content-center ${styles.noWrap}`}><p>{moment(job.jobPostEnd).format('DD MMM YYYY')}</p></Col>
											<Col className={`d-flex align-items-center justify-content-center ${styles.noWrap}`}><p>{moment(job.createdAt).format('DD MMM YYYY')}</p></Col>
											<Col className='d-flex align-items-center justify-content-center'><p>{job.application}</p></Col>
										</Row>
									</div>
								)
							})
						)}
					</div>
				</table>
			</div>

			<Row style={{ marginTop: '20px' }}>
				<Col />
				<Col>
					<ReactPaginate
						containerClassName={styles.pagination}
						previousClassName="page-item"
						nextLinkClassName="page-link"
						// activeClassName="active"
						activeLinkClassName={styles.paginationActive}
						pageClassName="page-item"
						pageLinkClassName="page-link"
						previousLinkClassName="page-link"
						nextClassName="page-item"
						breakLinkClassName="page-link"
						breakClassName="page-item"
						previousLabel={<FontAwesomeIcon icon={faChevronLeft} />}
						pageCount={pageCount}
						onPageChange={handlePageClick}
						nextLabel={<FontAwesomeIcon icon={faChevronRight} />}
						pageRangeDisplayed={3}
						marginPagesDisplayed={3}
						breakLabel="..."
						forcePage={toPage}
					// renderOnZeroPageCount={null}
					/>
				</Col>
				<Col style={{ display: 'flex', justifyContent: 'flex-end' }}>
					<span style={{ fontSize: '14px', color: '#5B7493', paddingTop: '5px' }}>Go to page</span>
					<FormControl
						style={{ width: '15%', display: 'inline-block', margin: '0 10px', height: '35px' }}
						onChange={e => {
							numbersOnly(e.target.value)
						}}
						value={filterPage}
					/>
					<Button onClick={submitPageNumber} variant='primary' className={styles.cusBtn}>
						Go
					</Button>
				</Col>
			</Row>
		</div>
	)
}

export default Jobs